import cn from 'classnames';
import PropTypes from 'prop-types';

import Radio from 'components/Radio';
import styles from 'styles/components/checkout/caap/listItem.scss';

const ListItem = ({ children, index, isChecked, isDisabled, isExpired, itemKey, listType, onChange }, { testId = f => f }) => {
  const itemId = `radio-item-${index}-${itemKey}`;
  const itemStyles = cn({
    [styles.radioButtonContainer]: true,
    [styles.address]: listType === 'address',
    [styles.showOnlySmallScreen]: listType === 'address'
  });
  return (
    <label htmlFor={itemId}>
      <span className={itemStyles} data-test-id={testId('listItemRadioButtonContainer')}>
        <Radio
          checked={isChecked}
          disabled={isDisabled}
          data-expired={isExpired}
          id={itemId}
          name={itemId}
          onChange={() => onChange(itemKey, isExpired)}
          data-test-id={testId('listItemRadioButton')}
        />
      </span>
      { children }
    </label>
  );
};

ListItem.contextTypes = {
  testId: PropTypes.func
};

export default ListItem;
